// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-container {
    display: table;
}

.fab-card {
    position: absolute;
    width: 1300px;
    height: 800px;
    /* background-color:black; */
    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */
    box-shadow: 0px 1px 4px 1px #888888;
}

.card-close {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 22px;
    width: 22px;
    color: rgba(0, 0, 0, 0.7);
    background-color: transparent;
    font-size: 12px;
    cursor: move !important;
}

.card-move-area {
    z-index: 999;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 22px;
}

.card-close i {
    float: right;
}

.fab-iframe {
    position: absolute;
    width: 800px;
    height: 600px;
    background-color: black;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    /* box-shadow: 0px 2px 6px -1px #888888; */
}

.iframe-header {
    display: block;
    height: 22px;
    width: 100%;
    color: white;
    background-color: black;
    font-size: 12px;
    text-align: center;
    line-height: 22px;
}

.iframe-header i {
    float: right;
    color: white;
}

.iframe-class {
    display: block;
    height: 100%;
    transform-origin: 0 0;
    /* transform-origin:left top; */
}

.ng-draggable {
    cursor: move;
}

.dialog-modal {
    /* display: none; */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    /*background-color: rgb(0,0,0); /* Fallback color */
    /*background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
::ng-deep .fuxa-dialog-property .mat-dialog-container {
    padding: 0;
}

.dialog-modal-content {
    border: 1px solid #888;
    box-shadow: 0 0 12px #000000 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.dialog-modal-close {
    position: relative;
    top: 0px;
    right: 0px;
    height: 22px;
    width: 100%;
    color: rgba(0, 0, 0, 0.7);
    background-color: transparent;
    font-size: 12px;
    cursor: move !important;
}

.dialog-modal-close i {
    float: right;
}

/* input */
.dialog-input {
    z-index: 9999; /* Sit on top */
    box-shadow: 1px 2px 5px -1px #888;
    position: absolute;
    padding: 5px;
    background-color: #fff;
    min-width: 80px;
    border: 0.5px solid #888;
    border-radius: 2px;
}

.dialog-input input {
    border: 0.5px solid rgba(0,0,0,0.1);
    border-radius: 2px;
    padding: 6px 3px 7px 4px;
    width: 100%;
    display: block;
    margin: 2px auto;
}

.dialog-input button {
    min-width: 80px;
}`, "",{"version":3,"sources":["webpack://./src/app/fuxa-view/fuxa-view.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,cAAc,EAAE,4BAA4B;IAC5C,mDAAmD;IACnD,0DAA0D;AAC9D;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,aAAa,EAAE,eAAe;IAC9B,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".view-container {\n    display: table;\n}\n\n.fab-card {\n    position: absolute;\n    width: 1300px;\n    height: 800px;\n    /* background-color:black; */\n    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */\n    box-shadow: 0px 1px 4px 1px #888888;\n}\n\n.card-close {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    height: 22px;\n    width: 22px;\n    color: rgba(0, 0, 0, 0.7);\n    background-color: transparent;\n    font-size: 12px;\n    cursor: move !important;\n}\n\n.card-move-area {\n    z-index: 999;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    height: 22px;\n}\n\n.card-close i {\n    float: right;\n}\n\n.fab-iframe {\n    position: absolute;\n    width: 800px;\n    height: 600px;\n    background-color: black;\n    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n    /* box-shadow: 0px 2px 6px -1px #888888; */\n}\n\n.iframe-header {\n    display: block;\n    height: 22px;\n    width: 100%;\n    color: white;\n    background-color: black;\n    font-size: 12px;\n    text-align: center;\n    line-height: 22px;\n}\n\n.iframe-header i {\n    float: right;\n    color: white;\n}\n\n.iframe-class {\n    display: block;\n    height: 100%;\n    transform-origin: 0 0;\n    /* transform-origin:left top; */\n}\n\n.ng-draggable {\n    cursor: move;\n}\n\n.dialog-modal {\n    /* display: none; */\n    position: fixed; /* Stay in place */\n    z-index: 1; /* Sit on top */\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    /*background-color: rgb(0,0,0); /* Fallback color */\n    /*background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n}\n\n/* Modal Content/Box */\n::ng-deep .fuxa-dialog-property .mat-dialog-container {\n    padding: 0;\n}\n\n.dialog-modal-content {\n    border: 1px solid #888;\n    box-shadow: 0 0 12px #000000 !important;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.dialog-modal-close {\n    position: relative;\n    top: 0px;\n    right: 0px;\n    height: 22px;\n    width: 100%;\n    color: rgba(0, 0, 0, 0.7);\n    background-color: transparent;\n    font-size: 12px;\n    cursor: move !important;\n}\n\n.dialog-modal-close i {\n    float: right;\n}\n\n/* input */\n.dialog-input {\n    z-index: 9999; /* Sit on top */\n    box-shadow: 1px 2px 5px -1px #888;\n    position: absolute;\n    padding: 5px;\n    background-color: #fff;\n    min-width: 80px;\n    border: 0.5px solid #888;\n    border-radius: 2px;\n}\n\n.dialog-input input {\n    border: 0.5px solid rgba(0,0,0,0.1);\n    border-radius: 2px;\n    padding: 6px 3px 7px 4px;\n    width: 100%;\n    display: block;\n    margin: 2px auto;\n}\n\n.dialog-input button {\n    min-width: 80px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
